import { forwardRef, useImperativeHandle, useRef } from 'react';
import classNames from 'classnames';

import styles from './index.module.less';
import { MediaTypeAcceptType } from './config';
import { IBaseImageUploader } from './interface';

const BaseImageUploader = forwardRef<IBaseImageUploader.ForwardRef, IBaseImageUploader.Props>(
	(props, ref) => {
		const { className, children, onChange, media = 'image', ...rest } = props;

		const inputRef = useRef<HTMLInputElement | null>(null);
		const containerRef = useRef<HTMLDivElement | null>(null);

		//点击上传图片
		const handleUpload = async () => {
			inputRef.current?.click();
		};

		// 处理文件选择
		const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
			const file = e.target.files?.[0] || null;
			onChange?.(file);
		};

		const handleInputClick = (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
			// 阻止点击事件冒泡到祖先元素
			event.stopPropagation();
			// 每次点击前都需要清空上一次的值, 要不然上传同一张图, 上传不上去
			clearInput();
		};

		const clearInput = () => {
			if (inputRef.current) {
				inputRef.current.value = '';
			}
		};

		useImperativeHandle(
			ref,
			() => ({
				select: handleUpload,
				clear: clearInput,
				getContainer: () => containerRef.current,
			}),
			[],
		);

		return (
			<div ref={containerRef} className={classNames(styles.uploaderWrapper, className)} {...rest}>
				{children}
				<input
					type="file"
					accept={MediaTypeAcceptType[media]}
					onChange={handleFileChange}
					ref={inputRef}
					onClick={handleInputClick}
				/>
			</div>
		);
	},
);

export default BaseImageUploader;
